import classnames from './classnames';

export {
  // eslint-disable-next-line import/prefer-default-export
  classnames
};
